export default "__VITE_ASSET__0b5f8dc2__"